import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from '../../../services/image-resize.service';
import {Marca} from '../../../../model/class/Marca';
import {ToastsManager} from 'ng2-toastr';
import {MarcaService} from '../../../services/marca/marca.service';

@Component({
  selector: 'app-crear-marca',
  templateUrl: './crear-marca.component.html',
  styleUrls: ['./crear-marca.component.css']
})
export class CrearMarcaComponent implements OnInit {

  @Input() newMarca: Marca;

  editando = false;
  loaders = {
    form: false,
    image: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  constructor(
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService,
    private toasts: ToastsManager,
    private marcaService: MarcaService,
  ) { }

  ngOnInit() {
    if (this.newMarca.id) {
      this.editando = true;
    }
  }

  asigneImage(event: any) {
    if (this.uploader.queue[0]) {
      const file = this.uploader.queue[0]._file;
      if (file) {
        this.loaders.image = true;
        this.newMarca.nuevaImagen = file;
        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newMarca.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
          });
      }
    } else {
      console.log('Archivo no valido');
    }
    this.uploader.queue = [];
  }

  onSubmit() {
    this.loaders.form = true;
    if (this.editando) {
      this.marcaService.edit(this.newMarca.id, this.newMarca.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Marca a sido modificada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al modificar la Marca.`);
          }
        );

    } else {
      console.log('Creao!');
      const objMarca = new Marca(this.newMarca);
      this.marcaService.create(objMarca.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Marca a sido creada exitosamente.`);
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al crear la Marca.`);
          }
        );

    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-marca/crear-marca.component.ts